import { g as __rest, b as __assign } from '../../../../../_tslib-7a01aab4.js';
import React from 'react';

var FooterInfo = function (_a) {
    var children = _a.children, flexEnd = _a.flexEnd, rest = __rest(_a, ["children", "flexEnd"]);
    return (React.createElement("div", __assign({ className: "pgc-game-footer-info ".concat(flexEnd ? 'flex-end' : '') }, rest), children));
};

export { FooterInfo };
